const _excluded = ["size"];
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from "react";
var Favorite24 = function Favorite24(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("path", {
      d: "m22.711 10.71-4.651 4.642.93 6.511a1 1 0 0 1-1.44 1.03L12 20.123l-5.55 2.77a1 1 0 0 1-1.44-1.03l.93-6.511-4.651-4.642a1.03 1.03 0 0 1-.24-1.03.987.987 0 0 1 .81-.67L8.3 8.09l2.78-6.482a1 1 0 0 1 1.84 0L15.7 8.09l6.441.92a.987.987 0 0 1 .832 1.218 1.028 1.028 0 0 1-.262.482z",
      fill: "currentColor",
    })
  );
};
Favorite24.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};
var Favorite16 = function Favorite16(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("path", {
      fill: "currentColor",
      d: "m15.14 7.14-3.1 3.095.62 4.34a.666.666 0 0 1-.96.687L8 13.415l-3.7 1.847a.667.667 0 0 1-.912-.332c-.048-.112-.065-.234-.048-.355l.62-4.34L.859 7.14a.686.686 0 0 1-.16-.687.658.658 0 0 1 .54-.446l4.294-.614 1.853-4.321a.667.667 0 0 1 1.227 0l1.853 4.321 4.294.614a.658.658 0 0 1 .555.812.686.686 0 0 1-.175.32Z",
    })
  );
};
Favorite16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16",
};
const sizeMap = {
  24: Favorite24,
  16: Favorite16,
};
export function Favorite(_ref) {
  let { size = "24" } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const Icon = sizeMap[size] || sizeMap["24"];
  if (
    process.env.NODE_ENV !== "production" &&
    process.env.NODE_ENV !== "test" &&
    !sizeMap[size]
  ) {
    throw new Error(
      "The '".concat(
        size,
        "' size is not supported by the 'Favorite' icon. Please use one of the available sizes: '16', '24'."
      )
    );
  }
  return /*#__PURE__*/ React.createElement(Icon, props);
}
